module.exports = __webpack_public_path__ + "static/media/Avatars_Male-12.9c977070.png";